<template>
  <v-card>
    <v-card-title>
      Campground
      <v-spacer/>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      />
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="campgroundReport"
      :search="search"
      class="elevation-1"
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <td>{{ props.item.campgroundName }}</td>
        <td>{{ props.item.adult }}</td>
        <td>{{ props.item.junior }}</td>
        <td>{{ props.item.child }}</td>
        <td>{{ props.item.total }}</td>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
// import vuex mapping
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      search: '',
      headers: [
        {
          text: 'Campground',
          value: 'campgroundName',
          sortable: true
        },
        {
          text: 'Adult Nights',
          value: 'adult',
          sortable: true
        },
        {
          text: 'Junior Nights',
          value: 'junior',
          sortable: true
        },
        {
          text: 'Child Nights',
          value: 'child',
          sortable: true
        },
        {
          text: 'Total Camper Nights',
          value: 'total',
          sortable: true
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      campgroundReport: 'reports/campgroundReport'
    })
  }
}
</script>
